import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


import Tools from './components/Tools';
import Login from './components/AccountComponents/Login'; 
import Register from './components/AccountComponents/Register'; 
import ForgotPassword from './components/AccountComponents/ForgotPassword';
import UpdatePassword from './components/AccountComponents/UpdatePassword';

import Navigation from './components/Navigation';

import Interview from './components/ProjectComponents/Interview';


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { NavigationProvider } from './utilities/NavigationContext';
import { AuthProvider } from './utilities/AuthContext';
import { SharedFunctionProvider } from './utilities/SharedFunctionContext';

import PrivateRoutes from './utilities/PrivateRoutes';

// Projects
import Explore from './components/ProjectComponents/Explore';
import InterviewProject from './components/ProjectComponents/InterviewProject';
import RealTime from './components/ProjectComponents/RealTime';
import QAKnowledgeBase from './components/ProjectComponents/QAKnowledgeBase';


// working project
import GPCCMP from './components/ProjectComponents/GPCCMP';
import Opioid from './components/ProjectComponents/Opioid';
import Transcribe from './components/ProjectComponents/Transcribe';

//Analytics
import Log from './components/AnalyticComponents/Log';
import AnalyticsDashboard from './components/AnalyticComponents/AnalyticDashboard';
import AllUser from './components/AnalyticComponents/AllUser';
import Lead from'./components/AnalyticComponents/Lead';

// Community
import Discussion from './components/CommunityComponents/Discussion';
import Community from './components/MainComponents/Community';
import Feedback from './components/ProjectComponents/Feedback';
import Roadmap from './components/ProjectComponents/Roadmap';

// Transaction
import Usage from './components/AccountComponents/Usage';
import UserAccount from './components/StripeComponents/UserAccount';
import BillingHistory from './components/StripeComponents/BillingHistory';
import Pricing from './components/StripeComponents/Pricing';
import BillingSuccess from './components/StripeComponents/BillingSuccess';
import BillingCancel from './components/StripeComponents/BillingCancel';
import CreditTopupSuccess from './components/StripeComponents/CreditTopupSuccess';
import CreditTopupCancel from './components/StripeComponents/CreditTopupCancel';

// Agreement
import UserAgreementManager from './components/ProjectComponents/UserAgreementManager';

// rewrite 
import Master from './components/Master';

// Peer to pper
import Library from './components/ProjectComponents/Library';

// additional project
import VoiceWidget from './components/ProjectComponents/VoiceWidget';
import Conversation from './components/ProjectComponents/Conversation';


class App extends React.Component {

  render() {

    return (
      <Router>
        <AuthProvider>
        <NavigationProvider>
        <SharedFunctionProvider>
            <ToastContainer />
            <Navigation />

            <Routes>
             
              <Route path="/" element={<Login/>} />
              <Route element={<PrivateRoutes />}>

                  <Route path="/tools" element={<Tools />} />
                  <Route path="/opioid" element={<Opioid />} />
                  <Route path="/master" element={<Master />} />


                  {/* Admin */}
                  <Route path="/usage" element={<Usage />} />
                  <Route path="/log" element={<Log />} />
                  <Route path="/analytics" element={<AnalyticsDashboard />} />
                  <Route path='/agreement' element={<UserAgreementManager />} />

                  
                  {/* Transaction */}
                  <Route path="/account" element={<UserAccount />} />
                  <Route path="/billing" element={<BillingHistory />} />
                  <Route path="/pricing" element={<Pricing />} />
  
                  {/* Community Discussion*/}

                  <Route path="/community" element={<Community />} />
                  <Route path="/feedback" element={<Feedback />} />
                  <Route path="/roadmap" element={<Roadmap />} />


                  {/* Main Application */}
                  <Route path="/planning" element={<GPCCMP />} />
                  <Route path="/library" element={<Library />} />
                  <Route path="/discussion" element={<Discussion />} />

  
              </Route>       
                  <Route path="/billing/success" element={<BillingSuccess />} />
                  <Route path="/billing/cancel" element={<BillingCancel />} />
                  <Route path="/billing/topup-success" element={<CreditTopupSuccess />} />
                  <Route path="/billing/topup-cancel" element={<CreditTopupCancel />} />
         
              {/* User pathway*/}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgotpassword" element={<ForgotPassword />} />
              <Route path="/updatepassword" element={<UpdatePassword />} />


              {/* Projects */}
              <Route path="/realtime" element={<RealTime />} />
              <Route path="/interview" element={<Interview />} />
              <Route path="/project" element={<InterviewProject />} />
              <Route path="/referrence" element={<QAKnowledgeBase />} />
               <Route path="/alluser" element={<AllUser />} />

              <Route path="/voicebot" element={<VoiceWidget />} />
              <Route path='/lead' element={<Lead />} />


            </Routes>
        </SharedFunctionProvider>
        </NavigationProvider>
        </AuthProvider>
      </Router>
    );
  }
}

export default App;
